module.exports = __webpack_public_path__ + "img/精准定向投放@2x.e083bd3c.png";